/**
 * Customer Redirect Handler
 * Simple post-login redirects based on company custom.ski_customer metafield
 */

class CustomerRedirectHandler {
  constructor() {
    this.settings = window.customerRedirectSettings || {};
    this.enabled = this.settings.enabled !== false;

    if (!this.enabled) {
      return;
    }

    this.init();
  }

  init() {
    // This is now a fallback only - main redirect happens in <head>
    // Only run if somehow the head redirect didn't work
    if (this.isHomepage() && !this.isOnSkiPage() && this.isLoggedIn()) {
      this.handleHomepageRedirect();
    }
  }

  wasServerSideRedirectHandled() {
    // Check if server-side redirect logic should have handled this
    return window.theme?.customer?.companySkiMetafield === true && this.settings.skiPageUrl;
  }

  isHomepage() {
    return window.location.pathname === '/' ||
           window.location.pathname === '' ||
           window.location.pathname === '/pages/frontpage';
  }

  isOnSkiPage() {
    if (!this.settings.skiPageUrl) {
      return false;
    }

    try {
      const skiPagePath = new URL(this.settings.skiPageUrl, window.location.origin).pathname;
      const currentPath = window.location.pathname;
      return currentPath === skiPagePath;
    } catch (error) {
      return false;
    }
  }

  isLoggedIn() {
    // Check if customer data is available (indicating logged in state)
    return !!window.theme?.customer?.id;
  }

  handleHomepageRedirect() {
    try {
      // Use customer data that's already available from server-side
      const customer = window.theme?.customer;
      if (!customer) {
        return;
      }

      const companySkiValue = customer.companySkiMetafield;

      // If company custom.ski_customer is true, redirect to configured page
      if (companySkiValue === true || companySkiValue === 'true') {
        const skiPageUrl = this.settings.skiPageUrl;
        if (skiPageUrl) {
          // Check if we're not already on the ski page
          const currentPath = window.location.pathname;
          const skiPagePath = new URL(skiPageUrl, window.location.origin).pathname;

          if (currentPath !== skiPagePath) {
            window.location.replace(skiPageUrl);
            return;
          }
        }
      }

    } catch (error) {
      // Silent error handling for production
    }
  }

  getCustomerData() {
    // Use customer data from theme.liquid (server-side)
    if (window.theme?.customer) {
      return window.theme.customer;
    }

    return null;
  }
}

// Initialize fallback handler (main redirect happens in <head>)
(function() {
  const settings = window.customerRedirectSettings;
  if (!settings?.enabled) return;

  const isHomepage = window.location.pathname === '/' ||
                     window.location.pathname === '' ||
                     window.location.pathname === '/pages/frontpage';

  // Quick check - don't run on ski page
  const isOnSkiPage = settings.skiPageUrl &&
                      window.location.pathname === new URL(settings.skiPageUrl, window.location.origin).pathname;

  // Only initialize as fallback on homepage
  if (isHomepage && !isOnSkiPage) {
    new CustomerRedirectHandler();
  }
})();

// Export for potential use by other scripts
window.CustomerRedirectHandler = CustomerRedirectHandler;
